import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const BookingOptionsTableHeaders = [
  { title: '#ID', align: 'start', key: 'id', placeholder: '00000' },
  { title: 'Type', align: 'start', key: 'category', placeholder: 'Option type' },
  { title: 'Name', align: 'start', key: 'optionName', placeholder: 'Option name' },
  { title: 'Actions', align: 'end', key: 'actions', sortable: false },
] as const satisfies readonly TableHeaderSpec[]
